export const WARRANTY_AVAILABILITY_LABELS = {
  UNAVAILABLE: '保固查詢尚未開放',
  NOT_RECORDED: '尚無銷售保固紀錄',
  AVAILABLE: '已有銷售保固',
};

export const REPAIR_STAGE_LABELS = {
  PENDING: '未處理',
  IN_PROGRESS: '處理中',
  RESOLVED: '已處理',
  COMPLETED: '完成',
};

/** SN 履歷來源：UNREGISTERED_REPAIR＝有明確報修但產品尚未登錄（不推定銷售／檢測資料）。 */
export const RECORD_SOURCE_LABELS = {
  V4: '現行登錄',
  LEGACY_ARCHIVE: '舊檢測資料',
  UNREGISTERED_REPAIR: '產品尚未登錄',
};

export function describeRecordSource(recordSource) {
  return RECORD_SOURCE_LABELS[recordSource] || '現行登錄';
}

export function describeWarrantyAvailability(availability) {
  return WARRANTY_AVAILABILITY_LABELS[availability] || '保固狀態未知';
}

export function describeRepairStage(stage, outcome) {
  const label = REPAIR_STAGE_LABELS[stage] || stage || '—';
  if (outcome === 'REFUSED') {
    return `${label}（拒修）`;
  }
  return label;
}

const CODE_MESSAGES = {
  PUBLIC_REPAIR_IDEMPOTENCY_KEY_REQUIRED: '請重新送出，這次送件缺少識別',
  PUBLIC_REPAIR_IDEMPOTENCY_KEY_INVALID: '送件識別無效，請重新建立報修',
  PUBLIC_REPAIR_SUBMISSION_KEY_REUSED: '同一送件識別不能改內容，請重新建立報修',
  PUBLIC_REPAIR_SERIAL_NUMBER_DUPLICATE: '同一張報修的序號不可重複',
  PUBLIC_QUERY_CODE_REQUIRED: '請輸入查詢碼',
  PUBLIC_REPAIR_REQUEST_NOT_FOUND: '找不到報修單',
  PUBLIC_SERIAL_NOT_FOUND: '找不到此序號',
  PUBLIC_LEGACY_INSPECTION_AMBIGUOUS: '此序號的舊檢測資料無法判定',
  PUBLIC_LEGACY_INSPECTION_QUERY_FAILED: '舊檢測資料暫時無法查詢',
  CUSTOMER_PORTAL_AUDIT_UNAVAILABLE: '附件暫時無法開啟，請稍後再試',
};

export function getCustomerPortalErrorMessage(error, fallback = '操作失敗，請稍後再試') {
  const data = error?.response?.data;
  const code = data?.code;
  if (code && CODE_MESSAGES[code]) {
    return CODE_MESSAGES[code];
  }
  return fallback;
}
